import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-phone-number-input/style.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import { HelmetProvider } from "react-helmet-async";
import "./i18n"; // Import i18next configuration
import initializePostHog from "./posthog";
// import ErrorBoundary from "./Utils/ErrorBoundary/ErrorBoundary";

initializePostHog(); // Khởi tạo PostHog
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    {/* <ErrorBoundary> */}
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
    {/* </ErrorBoundary> */}
  </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
